(ns app.front.routes
  "Routing tree.

  To have an item (or items) in automatically generated breadcrumb, use `:breadcrumb`
  which is a map with keys `:items` (vector of view name keywords with translations)
  or functions [{:keys [tr match]] -> [view-name params text] and `:fallback` which
  is a similar function for resolving the last item in the breadcrumb."
  (:require [app.domain.contractor-registration.model :as cr-model]
            [app.front.form.subs :as form-subs]
            [app.front.requirement.components :as req-components]
            [app.front.review-v2.subs :as review-subs]
            [app.front.ui.messages-panel :as messages-panel]
            [app.front.util :as futil]
            [app.front.view.admin.api-keys :as admin.api-keys]
            [app.front.view.admin.approver-groups :as admin.approver-groups]
            [app.front.view.admin.audit-log :as admin.audit-log]
            [app.front.view.admin.commands :as admin.commands]
            [app.front.view.admin.commands.add-execution-phase :as admin.commands.add-execution-phase]
            [app.front.view.admin.commands.authorize-sibling-groups :as admin.commands.authorize-sibling-group]
            [app.front.view.admin.commands.building-code-import :as admin.commands.building-code-import]
            [app.front.view.admin.commands.business-delete :as admin.commands.business-delete]
            [app.front.view.admin.commands.change-config-path :as admin.commands.change-config-path]
            [app.front.view.admin.commands.change-municipality :as admin.commands.change-ws-municipality]
            [app.front.view.admin.commands.create-inspection-groups :as admin.commands.create-inspection-groups]
            [app.front.view.admin.commands.data-import-repair :as admin.commands.data-import-repair]
            [app.front.view.admin.commands.dedupe-embeddings :as admin.commands.dedupe-embeddings]
            [app.front.view.admin.commands.delete-ag-entity :as admin.commands.delete-ag-entity]
            [app.front.view.admin.commands.delete-orphaned-registrations :as admin.commands.delete-orphaned-registrations]
            [app.front.view.admin.commands.execute-queries :as admin.commands.queries]
            [app.front.view.admin.commands.fix-assessment-reports :as admin.commands.fix-assessment-reports]
            [app.front.view.admin.commands.mass-delete-domain-group-properties :as admin.commands.mass-delete-domain-group-properties]
            [app.front.view.admin.commands.migrate-cr-trades :as admin.commands.migrate-cr-trades]
            [app.front.view.admin.commands.regenerate-pdf :as admin.commands.regenerate-pdf]
            [app.front.view.admin.commands.remove-duplicate-entities :as admin.commands.remove-duplicate-entities]
            [app.front.view.admin.commands.remove-duplicate-user :as admin.commands.remove-duplicate-user]
            [app.front.view.admin.commands.remove-orphaned-businesses :as admin.commands.remove-orphaned-businesses]
            [app.front.view.admin.commands.remove-user-from-ws :as admin.commands.remove-user-from-ws]
            [app.front.view.admin.commands.repair-cancelled-visit-booking :as admin.commands.repair-cancelled-visit-booking]
            [app.front.view.admin.commands.review-acceptances :as admin.commands.review-acceptances]
            [app.front.view.admin.commands.unblock-data-import :as admin.commands.unblock-data-import]
            [app.front.view.admin.commands.unlock-tasks :as admin.commands.unlock-tasks]
            [app.front.view.admin.commands.user-integrations :as admin.user-integrations]
            [app.front.view.admin.commands.workspace-delete :as admin.commands.workspace-delete]
            [app.front.view.admin.commands.workspace-restore :as admin.commands.workspace-restore]
            [app.front.view.admin.domain-groups.batch-group-creation :as admin.batch-group-creation]
            [app.front.view.admin.domain-groups.municipality-groups :as admin.municipality-groups]
            [app.front.view.admin.domain-groups.upper-tier-groups :as admin.upper-tier-groups]
            [app.front.view.admin.entity-lookup :as admin.entity-lookup]
            [app.front.view.admin.excise.core :as admin.excise]
            [app.front.view.admin.export-import :as admin.export-import]
            [app.front.view.admin.feature-flags :as admin.feature-flags]
            [app.front.view.admin.gis.core :as admin.gis-core]
            [app.front.view.admin.groups :as admin.groups]
            [app.front.view.admin.integration-messages :as admin.integration-messages]
            [app.front.view.admin.metrics :as admin.metrics]
            [app.front.view.admin.migration.activate-existing-addresses :as admin.migration.activate-existing-addresses]
            [app.front.view.admin.migration.activate-verified-properties :as admin.migration.activate-verified-properties]
            [app.front.view.admin.migration.add-domain-authority-users-as-domain-admins :as admin.migration.add-domain-authority-users-as-domain-admins]
            [app.front.view.admin.migration.assign-domain-agenda-templates :as admin.migration.assign-domain-agenda-templates]
            [app.front.view.admin.migration.backfill-planning-archiving-phases :as admin.migration.backfill-planning-archiving-phases]
            [app.front.view.admin.migration.bill-modified-ts :as admin.migration.bill-modified-ts]
            [app.front.view.admin.migration.change-licence-number :as admin.migration.change-licence-nro]
            [app.front.view.admin.migration.change-user-domain :as admin.migration.change-user-domain]
            [app.front.view.admin.migration.copy-committee-templates-to-domain :as admin.migration.copy-committee-templates-to-domain]
            [app.front.view.admin.migration.correct-cr-work-type-category :as admin.migration.correct-cr-work-type-category]
            [app.front.view.admin.migration.create-default-agenda-templates :as admin.migration.create-default-agenda-templates]
            [app.front.view.admin.migration.enable-property-management-for-all-domains :as admin.migration.enable-property-management]
            [app.front.view.admin.migration.fix-brantford-property-ids :as admin.migration.fix-brantford-property-ids]
            [app.front.view.admin.migration.fix-cashiers :as admin.migration.fix-cashiers]
            [app.front.view.admin.migration.inspection-template-visit-type :as admin.migration.inspection-template-visit-type]
            [app.front.view.admin.migration.link-acceptances-to-sub-reviews :as admin.migration.link-acceptances-to-sub-reviews]
            [app.front.view.admin.migration.link-primary-addresses :as admin.migration.link-primary-addresses]
            [app.front.view.admin.migration.migrate-clerks-to-meeting-coordinators :as admin.migration.migrate-clerks-to-meeting-coordinators]
            [app.front.view.admin.migration.migrate-property-units :as admin.migration.migrate-property-units]
            [app.front.view.admin.migration.migrate-statcan-form-to-version-2 :as admin.migration.migrate-statcan-form-to-version-2]
            [app.front.view.admin.migration.migrate-workspace-address-units :as admin.migration.migrate-workspace-address-units]
            [app.front.view.admin.migration.move-committees-to-domain :as admin.migration.move-committees-to-domain]
            [app.front.view.admin.migration.property-geojson :as admin.migration.property-geojson]
            [app.front.view.admin.migration.remove-cashier-authz :as admin.migration.remove-cashier-authz]
            [app.front.view.admin.migration.restrict-workspaces :as admin.migration.restrict-workspaces]
            [app.front.view.admin.migration.sub-review-modified-ts :as admin.migration.sub-review-modified-ts]
            [app.front.view.admin.migration.uri-path-ids :as admin.migration.uri-path-ids]
            [app.front.view.admin.oidc-configs :as admin.oidc-configs]
            [app.front.view.admin.reporting.core :as admin.reporting]
            [app.front.view.admin.signal-debugger :as admin.signal-debugger]
            [app.front.view.admin.superdomain :as admin.superdomain]
            [app.front.view.admin.tenant-management.create-view :as admin.tenant-management-create]
            [app.front.view.admin.tenant-management.detail-view :as admin.tenant-management-detail]
            [app.front.view.admin.tenant-management.list-view :as admin.tenant-management]
            [app.front.view.admin.users :as admin.users]
            [app.front.view.admin.ws-export.view :as admin.ws-export]
            [app.front.view.application :as app-view]
            [app.front.view.application-wizard.core :as application-wizard]
            [app.front.view.application-wizard.end :as application-wizard-end]
            [app.front.view.application.target-times :as application-target-times]
            [app.front.view.audit-log.list :as audit-log-list]
            [app.front.view.bond.new :as new-bond]
            [app.front.view.bond.view :as bond-view]
            [app.front.view.business.view :as business-view]
            [app.front.view.committees.admin :as admin.committees]
            [app.front.view.committees.core :as committees]
            [app.front.view.committees.subs :as committee-subs]
            [app.front.view.committees.template-editor :as committee-template-editor]
            [app.front.view.complaint.dashboard :as complaints]
            [app.front.view.complaint.public-view :as public-complaints]
            [app.front.view.contact-request.public-view :as public-contact-request]
            [app.front.view.contractor-registration.search :as contractor-registration-search]
            [app.front.view.contractor-registration.view :as cr-view]
            [app.front.view.conversations.core :as conversations]
            [app.front.view.create-application.create-v2 :as create-v2]
            [app.front.view.dashboard :as dashboard]
            [app.front.view.dev :as view.dev]
            [app.front.view.dispatch.core :as dispatch-inspections]
            [app.front.view.escrow.account :as escrow-account]
            [app.front.view.escrow.account-base :as escrow-account-base]
            [app.front.view.form :as form]
            [app.front.view.group.admin.ai.core :as group.admin.rag-files]
            [app.front.view.group.admin.approver-groups :as group.admin.approver-groups]
            [app.front.view.group.admin.approver-groups-domain :as group.admin.approver-groups-domain]
            [app.front.view.group.admin.bonds.accounts :as group.admin.bonds]
            [app.front.view.group.admin.branding.core :as group.admin.branding]
            [app.front.view.group.admin.conditions.core :as group.admin.conditions]
            [app.front.view.group.admin.config :as group.admin.config]
            [app.front.view.group.admin.core :as group.admin.core]
            [app.front.view.group.admin.escrow.accounts :as group.admin.escrow]
            [app.front.view.group.admin.fees.core :as group.admin.fees]
            [app.front.view.group.admin.files :as group-files]
            [app.front.view.group.admin.form-field-selection :as ff-selection]
            [app.front.view.group.admin.form-schemas.declaration-editor :as group.admin.declaration-editor]
            [app.front.view.group.admin.form-schemas.form :as group.admin.form]
            [app.front.view.group.admin.form-schemas.forms :as group.admin.forms]
            [app.front.view.group.admin.import.core :as group.admin.import]
            [app.front.view.group.admin.import.post-processing :as group.admin.import.further]
            [app.front.view.group.admin.import.session :as group.admin.import.session]
            [app.front.view.group.admin.inspections.core :as group.admin.inspections]
            [app.front.view.group.admin.inspections.order-template :as order-template-editor]
            [app.front.view.group.admin.inspections.pdf-template-editor :as pdf-template-editor]
            [app.front.view.group.admin.integration.core :as group.admin.integration]
            [app.front.view.group.admin.locales :as group.admin.locales]
            [app.front.view.group.admin.mfa.core :as group.admin.mfa]
            [app.front.view.group.admin.payment :as group.admin.payment]
            [app.front.view.group.admin.property.config.core :as group.admin.property-mgmt-config]
            [app.front.view.group.admin.review-config :as group.admin.review-config]
            [app.front.view.group.admin.standard-texts.core :as group.admin.standard-texts]
            [app.front.view.group.admin.states :as admin.states]
            [app.front.view.group.admin.subs :as gas]
            [app.front.view.group.admin.template :as group.admin.template]
            [app.front.view.group.admin.templates :as group.admin.templates]
            [app.front.view.group.admin.templates.stamps.core :as stamps]
            [app.front.view.group.admin.templates.subs :as template-subs]
            [app.front.view.group.admin.templates.system-email :as group.admin.templates.system-email]
            [app.front.view.group.admin.user-management :as group.admin.user-management]
            [app.front.view.group.admin.users.core :as group.admin.users]
            [app.front.view.group.admin.verdict-template :as group.admin.verdict-template]
            [app.front.view.group.admin.workdays-editor.core :as group.admin.workdays-editor]
            [app.front.view.group.reporting.assessment :as group.reporting.assessment]
            [app.front.view.group.reporting.bonds :as group.reporting.bonds]
            [app.front.view.group.reporting.cases :as group.reporting.cases]
            [app.front.view.group.reporting.code-report :as code-report]
            [app.front.view.group.reporting.complaints :as group.reporting.complaints]
            [app.front.view.group.reporting.core :as group.reporting.core]
            [app.front.view.group.reporting.escrow :as group.reporting.escrow]
            [app.front.view.group.reporting.inspections :as group.reporting.inspections]
            [app.front.view.group.reporting.payments :as group.reporting.payments]
            [app.front.view.group.reporting.permit :as group.reporting.permit]
            [app.front.view.group.reporting.reviews :as group.reporting.reviews]
            [app.front.view.group.reporting.statcan-occupancy :as group.reporting.statcan-occupancy]
            [app.front.view.group.reporting.statcan-spreadsheet :as group.reporting.statcan-spreadsheet]
            [app.front.view.group.reporting.workspaces :as group.reporting.workspaces]
            [app.front.view.inspections.acknowledge :as inspections.acknowledge]
            [app.front.view.inspections.events :as inspection-events]
            [app.front.view.inspections.my-today :as inspections.my-today]
            [app.front.view.inspections.visit :as inspection-visit]
            [app.front.view.landing-page :as landing-page]
            [app.front.view.licence.search :as licence-search]
            [app.front.view.licence.view :as licence-view]
            [app.front.view.login :as login]
            [app.front.view.meetings.core :as meetings]
            [app.front.view.navigation :as nav]
            [app.front.view.payment.checkout :as checkout]
            [app.front.view.payment.checkout-v2 :as checkout-v2]
            [app.front.view.pdf-markup.core :as pdf-markup]
            [app.front.view.periodic-inspection :as periodic-inspection]
            [app.front.view.permit.core :as permit]
            [app.front.view.permit.renewal :as renewal]
            [app.front.view.planning-report.core :as planning-report]
            [app.front.view.pre-consultation-meetings.view :as pre-consultation-meetings]
            [app.front.view.pre-consultation.view :as pre-consultation-view]
            [app.front.view.profile.core :as profile]
            [app.front.view.project :as project]
            [app.front.view.property.audit-log :as property-audit-log]
            [app.front.view.property.dashboard.core :as property-dashboard]
            [app.front.view.property.gis-import.import-session :as property-gis-import-session]
            [app.front.view.property.gis-import.session-list :as property-gis-import]
            [app.front.view.property.gis-import.update-session :as property-gis-update-session]
            [app.front.view.property.mass-delete :as property-mass-delete]
            [app.front.view.property.view :as property-view]
            [app.front.view.public-notice.decision-download :as decision-download]
            [app.front.view.public-notice.subscribe :as public-notice-subscribe]
            [app.front.view.public-records.core :as public-records]
            [app.front.view.recently-viewed :as recently-viewed]
            [app.front.view.registration.core :as registration]
            [app.front.view.registration.terms-of-service :as tos]
            [app.front.view.reset-password.core :as reset-password]
            [app.front.view.search.core :as search]
            [app.front.view.sign-off :as sign-off]
            [app.front.view.workspace.copy :as workspace-copy]
            [app.front.view.workspace.neighbour-properties :as neighbour-properties]
            [app.front.view.workspace.primary-actions :as ws-primary-actions]
            [app.front.view.workspace.route-subs :as ws-route-subs]
            [app.front.view.workspace.top-bar :as ws-top-bar]
            [clojure.string :as str]
            [core.front.event :refer [>evt]]
            [schema.core :as s]))


(def routes
  ["/:branding/"
   {:breadcrumb  {:items [nav/dashboard-nav-item]}
    :parameters  {:path  {:branding s/Str}
                  :query tos/route-parameters}
    :controllers (vec
                   (concat tos/doc-modal-controller
                           [{:parameters {:path [:branding]}
                             :start      (fn [{{:keys [branding]} :path}]
                                           (>evt [:branding/set-branding branding]))}]))}
   ;; Landing page at /:branding/ root (when feature flag enabled, server renders this)
   ["" landing-page/route]
   ["public-records" public-records/route]
   ["create-complaint" public-complaints/route]
   ["contact-request" public-contact-request/route]
   ["dashboard" dashboard/dashboard-view]
   ["search" search/route]
   ["recently-viewed" recently-viewed/route]
   ["licence-search" licence-search/search-view]
   ["contractor-registration-search" contractor-registration-search/search-view]
   ["login"
    login/route-parameters
    ["" login/login-route]]
   ["my-profile" profile/profile-view]
   ["reset-password/:token" reset-password/new-password-view]
   ["reset-password"
    login/route-parameters
    ["" login/send-password-link-view]]
   ["group/:group-id"
    {:parameters  {:path {:group-id s/Int}}
     :controllers [{:parameters {:path [:group-id]}
                    :start      (fn [params]
                                  (let [group-id (-> params :path :group-id)]
                                    (>evt [::gas/set-group-id group-id])))
                    :stop       (fn [_]
                                  (>evt [::gas/set-group-id nil]))}]}
    ["/admin"
     {:controllers [{:parameters {:path [:group-id]}
                     :start      (fn [params]
                                   (let [group-id (-> params :path :group-id)]
                                     (>evt [::group.admin.core/fetch-config group-id])
                                     ;; for translations to work, we need permit types
                                     (>evt [::gas/fetch-permit-type-configs group-id])
                                     (>evt [::gas/fetch-management-views group-id])))}]}
     ["/user-management" group.admin.user-management/user-management-view]
     ["/users" group.admin.users/route]
     ["/payment" {}
      ["" group.admin.payment/route]
      ["/escrow" group.admin.escrow/route]]
     ["/config" group.admin.config/route]
     ["/stamps/new" stamps/new-route]
     ["/stamps/:stamp-id/edit" stamps/edit-route]
     ["/templates"
      {:parameters  {:path  {:group-id s/Int}
                     :query {(s/optional-key :tab) s/Str}}
       :breadcrumb  {:items [:view/group.admin.templates]}
       :controllers [{:parameters {:path [:group-id]}
                      :start      (fn [{{:keys [group-id]} :path}]
                                    (>evt [::group-files/fetch-files group-id])
                                    (>evt [::group.admin.inspections/fetch-inspections group-id]))}]}
      [""
       {:name        :view/group.admin.templates
        :own-layout? true
        :view        group.admin.templates/view
        :controllers [{:parameters {:path  [:group-id]
                                    :query [:tab]}
                       :start      (fn [{{:keys [group-id]} :path
                                         {:keys [tab]}      :query}]
                                     (>evt [::template-subs/fetch-templates group-id])
                                     (>evt [::template-subs/fetch-system-email-templates-when-needed group-id tab])
                                     (>evt [::gas/fetch-authority-groups group-id]))}
                      stamps/collection-controller]}]
      ["/system-emails/:email-type"
       {:name        :view/group.admin.system-email-template
        :breadcrumb  {:items ^:replace [group.admin.templates.system-email/templates-breadcrumb
                                        group.admin.templates.system-email/template-breadcrumb]}
        :view        group.admin.templates.system-email/editor-view
        :view-sub    [::template-subs/system-email-template-view-data]
        :parameters  {:path {:group-id   s/Int
                             :email-type s/Keyword}}
        :controllers [{:parameters {:path [:group-id :email-type]}
                       :start      (fn [{{:keys [group-id email-type]} :path}]
                                     (>evt [::template-subs/fetch-system-email-templates-when-needed
                                            group-id
                                            group.admin.templates.system-email/system-email-tab-param])
                                     (>evt [::template-subs/fetch-system-email-template-for-route
                                            group-id
                                            email-type]))}]}]
      ["/:template-id"
       {:name        :view/group.admin.template
        :breadcrumb  {:items ^:replace [group.admin.template/meeting-grandparent-breadcrumb
                                        group.admin.template/template-parent-breadcrumb
                                        group.admin.template/edit-template-breadcrumb]}
        :view        group.admin.template/view
        :parameters  {:path {:group-id    s/Int
                             :template-id s/Int}}
        :controllers [{:parameters {:path [:group-id :template-id]}
                       :start      (fn [params]
                                     (let [group-id    (-> params :path :group-id)
                                           template-id (-> params :path :template-id)]
                                       (>evt [::template-subs/fetch-template group-id template-id])
                                       ;; fetching all related templates for identify possible replacements
                                       (>evt [::template-subs/fetch-templates group-id])
                                       (>evt [::group.admin.template/prepare-template-for-edit])
                                       ;; form fields and party roles required for verdict templates
                                       (>evt [::group.admin.verdict-template/fetch-form-schemas group-id])
                                       (>evt [::gas/fetch-authority-groups group-id])
                                       (>evt [::gas/fetch-party-roles group-id])
                                       (>evt [::ff-selection/fetch-form-fields group-id])))}]}]
      ["/new/:template-type"
       {:name        :view/group.admin.template.new
        :view        group.admin.template/view
        :breadcrumb  {:items ^:replace [group.admin.template/meeting-grandparent-breadcrumb
                                        group.admin.template/template-parent-breadcrumb
                                        group.admin.template/new-template-breadcrumb]}
        :controllers [{:parameters {:path [:group-id :template-type]}
                       :start      (fn [params]
                                     (let [group-id (-> params :path :group-id)]
                                       (>evt [::gas/fetch-authority-groups group-id])
                                       (>evt [::gas/fetch-party-roles group-id])
                                       (>evt [::group.admin.template/prepare-template-for-edit])
                                       (case (-> params :path :template-type)
                                         :inspection-pdf-template
                                         (>evt [::pdf-template-editor/fetch-defaults group-id])
                                         :order-template
                                         (>evt [::order-template-editor/fetch-defaults])
                                         nil)))}]
        :parameters  {:path {:group-id      s/Int
                             :template-type (s/enum :inspection-pdf-template
                                                    :letter-pdf-template
                                                    :order-template
                                                    :package-pdf-template
                                                    :meeting-agenda-template)}}}]
      ["/new/:template-type/:permit-type"
       {:name        :view/group.admin.new.template.permit-type
        :view        group.admin.template/view
        :breadcrumb  {:items ^:replace [group.admin.template/template-parent-breadcrumb
                                        group.admin.template/new-template-breadcrumb]}
        :controllers [{:parameters {:path [:group-id :template-type :permit-type]}
                       :start      (fn [params]
                                     (let [group-id (-> params :path :group-id)]
                                       (>evt [::group.admin.template/prepare-template-for-edit])
                                       (>evt [::gas/fetch-authority-groups group-id])
                                       (>evt [::gas/fetch-party-roles group-id])))}]
        :parameters  {:path {:group-id      s/Int
                             :template-type (s/enum :package-pdf-template)
                             :permit-type   s/Str}}}]
      ["/committee-agenda/:committee-id" committee-template-editor/route]]
     ["/review-config" group.admin.review-config/route]
     ["/approver-groups" group.admin.approver-groups/route]
     ["/approver-groups-domain" group.admin.approver-groups-domain/route]
     ["/import"
      {:breadcrumb {:items [:view/group.admin.import]}}
      ["" group.admin.import/route]
      ["/:session-id" {}
       ["" group.admin.import.session/import-session-route]
       ["/post-processing" group.admin.import.further/route]]]
     ["/inspections" group.admin.inspections/route]
     ["/conditions" group.admin.conditions/route]
     ["/locales" group.admin.locales/route]
     ["/fees" group.admin.fees/route]
     ["/committees" admin.committees/committee-route]
     ["/meetings" admin.committees/meeting-route]
     ["/meetings/templates" admin.committees/meeting-templates-route]
     ["/tribunals" admin.committees/tribunal-route]
     ["/states" admin.states/route]
     ["/forms"
      {:breadcrumb {:items [:view/group.admin.forms]}}
      ["" group.admin.forms/route]
      ["/:schema-id" group.admin.form/route]]
     ["/declarations"
      {:breadcrumb {:items [:view/group.admin.forms]}}
      ["/:declaration-id" group.admin.declaration-editor/route]]
     ["/integration" group.admin.integration/route]
     ["/mfa" group.admin.mfa/route]
     ["/ai-files" group.admin.rag-files/route]
     ["/workdays" group.admin.workdays-editor/route]
     ["/branding" group.admin.branding/route]
     ["/bonds" group.admin.bonds/route]
     ["/standard-texts" group.admin.standard-texts/route]
     ["/property-management-config" group.admin.property-mgmt-config/route]]
    ["/reporting"
     {:breadcrumb  {:items [:view/group.reporting.base]}
      :own-layout? true}
     ["" group.reporting.core/route]
     ["/applications" group.reporting.permit/applications-route]
     ["/assessment" group.reporting.assessment/route]
     ["/cases" group.reporting.cases/route]
     ["/code-report" code-report/route]
     ["/complaints" group.reporting.complaints/route]
     ["/escrow" group.reporting.escrow/route]
     ["/bonds" group.reporting.bonds/route]
     ["/inspections" group.reporting.inspections/route]
     ["/licences" group.reporting.permit/licences-route]
     ["/payments" group.reporting.payments/route]
     ["/permits" group.reporting.permit/route]
     ["/workspaces" group.reporting.workspaces/route]
     ["/reviews" group.reporting.reviews/route]
     ["/statcan-spreadsheet" group.reporting.statcan-spreadsheet/route]
     ["/statcan-occupancy" group.reporting.statcan-occupancy/route]]
    ["/meetings"
     ["" meetings/route]]]
   ["registration/:token" registration/user-details-view]
   ["registration"
    login/route-parameters
    ["" login/registration-view]]
   ["application-wizard/:step" application-wizard/route]
   ["create-application/:part" create-v2/view-config]
   ["project/:project-id" project/project-view]

   ["conversations"
    {:controllers [{:start (fn [_]
                             (>evt [::conversations/init]))
                    :stop  (fn [_]
                             (>evt [::conversations/set-selected-workspace-id nil]))}]
     :breadcrumb  {:items [:view/conversations]}}
    [""
     {:name         :view/conversations
      :own-layout?  true
      :hide-footer? true
      :view         conversations/conversations-view}]]

   ["messages"
    {:parameters  {:query {(s/optional-key :workspace-id) s/Str}}
     :controllers [{:parameters {:query [:workspace-id]}
                    :start      (fn [params]
                                  (let [ws-id (some-> params :query :workspace-id)]
                                    (>evt [::messages-panel/set-fullscreen true])
                                    (>evt [::messages-panel/init ws-id])))
                    :stop       (fn [_]
                                  (>evt [::messages-panel/set-fullscreen false])
                                  (>evt [::conversations/set-selected-workspace-id nil]))}]
     :breadcrumb  {:items [:view/messages]}}
    [""
     {:name         :view/messages
      :own-layout?  true
      :hide-footer? true
      :view         messages-panel/full-screen-messages-view}]]

   ;;
   ;; Application list, application, and form:
   ;;

   ;; Remember to change also app.front.view.navigation when necessary.

   ["workspace"
    ["/:workspace-id"
     {:parameters      {:path  {:workspace-id s/Str}
                        :query {(s/optional-key :msg)    s/Bool
                                (s/optional-key :origin) s/Str}}
      :primary-actions ws-primary-actions/primary-actions-for-sub-header
      :breadcrumb      {:items    [ws-top-bar/project-or-business
                                   ws-top-bar/workspace-by-address]
                        :fallback ws-top-bar/breadcrumb-fallback}
      :controllers     [{:parameters {:path  [:workspace-id]
                                      :query [:msg :recipient]}
                         :start      (fn [params]
                                       (let [workspace-id (-> params :path :workspace-id)
                                             msg?         (-> params :query :msg)
                                             recipient    (some-> params :query :recipient futil/parse-int)]
                                         (futil/scroll-to-top)
                                         (futil/set-title workspace-id)
                                         (>evt [::app-view/navigate-workspace (:path params)])
                                         (>evt [::conversations/init-for-workspace workspace-id msg? recipient])
                                         (futil/scroll-to-anchor)))
                         :stop       (fn [_]
                                       (>evt [::app-view/exit-view])
                                       (>evt [::review-subs/reset-review-tab])
                                       (>evt [::review-subs/close-start-new-round-modal])
                                       (>evt [::application-target-times/close-editing])
                                       (futil/set-title nil))}
                        {:identity identity
                         :start    (fn [match]
                                     ;; this controller is for the scenario where the path doesn't change (hence the controller above is not executed)
                                     ;; but it needs to be checked if the workspace should redirect to acknowledgement
                                     (>evt [::app-view/navigate-acknowledgements match]))}]}
     [""
      {:name     :view/workspace
       :view     app-view/application
       :view-sub [::ws-route-subs/workspace-view-data]}]
     ["/pdf-markup/:attachment-id/:file-id"
      {:name              :view/pdf-markup
       :view              pdf-markup/view
       :full-screen-view? true
       :view-sub          [::pdf-markup/view-data]
       :breadcrumb        {:fallback pdf-markup/filename-breadcrumb}
       :parameters        {:path {:attachment-id s/Int :file-id s/Int}}
       :controllers       [{:parameters {:path [:workspace-id :attachment-id :file-id]}
                            :start      (fn [params] (>evt [::pdf-markup/enter (:path params)]))
                            :stop       (fn [_] (>evt [::pdf-markup/leave]))}]}]
     ["/wizard-resume" application-wizard/workspace-wizard-resume-route]
     ["/wizard-end" application-wizard-end/workspace-wizard-end-route]
     ["/wizard/:step" application-wizard/workspace-wizard-route]
     ["/copy" workspace-copy/view-config]
     ["/create-linked-workspace" workspace-copy/create-linked-workspace-view-config]
     ["/neighbour-properties"
      {:name        :view/neighbour-properties
       :view        neighbour-properties/view
       :controllers [{:parameters {:path [:workspace-id]}
                      :start      (fn [params]
                                    (>evt [::neighbour-properties/fetch-layer-property-id
                                           (-> params :path :workspace-id)]))}]
       :view-sub    [::ws-route-subs/workspace-sub-page-view-data]}]
     ["/form/:form-id"
      {:name        :view/form
       :view        form/form-view
       :view-sub    [::ws-route-subs/workspace-sub-page-view-data]
       :breadcrumb  {:items [ws-top-bar/form-by-name]}
       :parameters  {:path  {:form-id s/Int}
                     :query {(s/optional-key :review-id) s/Int}}
       :controllers [{:parameters {:path [:form-id]}
                      :start      (fn [params]
                                    (futil/scroll-to-top)
                                    (>evt [::form-subs/navigate-form (:path params)]))}]}]
     ["/sign-off" sign-off/route]
     ["/audit-log" audit-log-list/route]
     ["/permits"
      {:view-sub [::ws-route-subs/workspace-sub-page-view-data]
       :view     permit/permits-view}
      ["" {:name        :view/permits
           :parameters  {:path {:workspace-id s/Str}}
           :controllers [{:parameters {:path [:workspace-id]}
                          :start      (fn [params]
                                        (futil/scroll-to-top)
                                        (let [workspace-id (-> params :path :workspace-id)]
                                          (>evt [::inspection-events/fetch-inspections workspace-id])
                                          (>evt [::permit/fetch-templates workspace-id])
                                          (>evt [::permit/fetch-issuer-users workspace-id])
                                          (>evt [::renewal/check-renewal-availability workspace-id])))}]}]
      ["/sign" {:name        :view/sign-permits
                :parameters  {:path {:workspace-id s/Str}}
                :controllers [{:parameters {:path [:workspace-id]}
                               :start      (fn [_]
                                             (futil/scroll-to-top))}]}]]
     ["/reports"
      ["/draft/:report-id"
       {:name        :view/planning-draft-report
        :view        planning-report/report-view
        :view-sub    [::ws-route-subs/workspace-sub-page-view-data]
        :parameters  {:path {:workspace-id s/Str
                             :report-id    s/Int}}
        :controllers [{:parameters {:path [:workspace-id :report-id]}
                       :start      planning-report/on-navigate-to}]}]
      ["/final/:report-id"
       {:name        :view/planning-final-report
        :view        planning-report/report-view
        :view-sub    [::ws-route-subs/workspace-sub-page-view-data]
        :parameters  {:path {:workspace-id s/Str
                             :report-id    s/Int}}
        :controllers [{:parameters {:path [:workspace-id :report-id]}
                       :start      planning-report/on-navigate-to}]}]]
     ["/pre-consultation"
      {:controllers [{:stop (fn [_]
                              (>evt [::pre-consultation-view/reset-ui-state])
                              (>evt [::req-components/reset-ui-state]))}]}
      [""
       {:name     :view/workspace-pre-consultation
        :view     app-view/application
        :phase    :workspace.state/pre-consultation
        :view-sub [::ws-route-subs/workspace-view-data]}]
      ["/attachments"
       {:name       :view/pre-consultation-attachments
        :view       app-view/application
        :parameters {:query {(s/optional-key :id) s/Int}}
        :phase      :workspace.state/pre-consultation
        :view-sub   [::ws-route-subs/workspace-view-data]}]]
     ["/application"
      [""
       {:name        :view/workspace-application
        :view        app-view/application
        :phase       :workspace.state/application
        :view-sub    [::ws-route-subs/workspace-view-data]
        :parameters  {:query {(s/optional-key :review-id) s/Int}}
        :controllers [{:parameters {:query [:review-id]}
                       :start      (fn [params]
                                     (if-let [review-id (-> params :query :review-id)]
                                       (>evt [::review-subs/focus-review review-id])
                                       (futil/scroll-to-anchor)))
                       :stop       (fn [_]
                                     (>evt [::review-subs/collapse-reviews]))}]}]
      ["/attachments"
       {:name       :view/application-attachments
        :view       app-view/application
        :parameters {:query {(s/optional-key :id) s/Int}}
        :phase      :workspace.state/application
        :view-sub   [::ws-route-subs/workspace-view-data]}]]
     ["/execution"
      [""
       {:name     :view/workspace-execution
        :view     app-view/application
        :phase    :workspace.state/execution
        :view-sub [::ws-route-subs/workspace-view-data]}]
      ["/attachments"
       {:name       :view/execution-attachments
        :view       app-view/application
        :parameters {:query {(s/optional-key :id) s/Int}}
        :phase      :workspace.state/execution
        :view-sub   [::ws-route-subs/workspace-view-data]}]]
     ["/periodic-parent"
      {:controllers [{:stop (fn [_]
                              (>evt [::periodic-inspection/reset-ui-state])
                              (>evt [::req-components/reset-ui-state]))}]}
      [""
       {:name     :view/workspace-periodic-parent
        :view     app-view/application
        :phase    :workspace.state/periodic-parent
        :view-sub [::ws-route-subs/workspace-view-data]}]
      ["/attachments"
       {:name       :view/periodic-parent-attachments
        :view       app-view/application
        :parameters {:query {(s/optional-key :id) s/Int}}
        :phase      :workspace.state/periodic-parent
        :view-sub   [::ws-route-subs/workspace-view-data]}]]
     ["/archiving"
      [""
       {:name     :view/workspace-archiving
        :view     app-view/application
        :view-sub [::ws-route-subs/workspace-back-view-data]
        :phase    :workspace.state/archiving}]]

     ["/inspections"
      {}
      ["/:inspection-id"
       {:name            :view/inspection-visit
        :view            inspection-visit/view
        :phase           :workspace.state/execution
        :view-sub        [::inspection-visit/view-data]
        :primary-actions inspection-visit/top-bar-actions
        :breadcrumb      {:items [ws-top-bar/inspection-by-name]}
        :parameters      {:path {:workspace-id  s/Str
                                 :inspection-id s/Int}}
        :controllers     [{:parameters {:path [:workspace-id :inspection-id]}
                           :start      (fn [{{:keys [workspace-id inspection-id]} :path}]
                                         (>evt [::inspection-visit/get-files inspection-id])
                                         (>evt [::inspection-visit/initialize workspace-id inspection-id]))}]}]]
     ["/acknowledge" inspections.acknowledge/view]

     ["/payment/checkout" checkout/route]
     ["/payment-checkout/:payment-id" checkout-v2/route]]]


   ;;
   ;; Inspections
   ;;

   ["inspections"
    {}
    ["/dispatch" dispatch-inspections/route]
    ["/my" inspections.my-today/my-inspections]]

   ;;
   ;; Committees
   ;;

   ["committees"
    {:parameters  {:query {(s/optional-key :group-id) s/Int}}
     :breadcrumb  {:items [committees/committees-breadcrumb]}
     :controllers [{:parameters {:query [:group-id]}
                    :start      (fn [{{:keys [group-id]} :query}]
                                  (>evt [::committee-subs/fetch-committees group-id])
                                  (when group-id
                                    (>evt [::committee-subs/set-pre-selected-group-id group-id])))}]}
    ["" committees/route-all]
    ["/:committee-id" committees/route-one]]

   ;;
   ;; Code enforcement
   ;;

   ["code-enforcement"
    {}
    ["/complaints" complaints/route]]

   ;;
   ;; Licencing
   ;;
   ["licences"
    {}
    ["/:group-id/:licence-id"
     licence-view/route]]

   ;;
   ;; Business
   ;;
   ["business"
    {}
    ["/:business-id"
     business-view/route]]

   ;;
   ;; Escrow
   ;;
   ["escrow"
    ["/:account-id"
     escrow-account-base/base-route
     ["/outstanding-payments"
      escrow-account/outstanding-payments-route]
     ["/transactions"
      escrow-account/transactions-route]
     ["/attachments"
      escrow-account/attachments-route]
     ["/payment/checkout" checkout/route-escrow]
     ["/payment-checkout/:payment-id" checkout-v2/route-escrow]]]

   ;;
   ;; Contractor registration
   ;;
   ["contractor-registration"
    {:parameters {:path {:cr-id cr-model/ContractorRegistrationId}}}
    ["/:cr-id"
     cr-view/route]]

   ;;
   ;; Admin tools
   ;;

   ["admin"
    {}
    ["/integration-messages" admin.integration-messages/route]
    ["/excise" {}
     ["" admin.excise/route]
     ["/:type/:id" admin.excise/perform-route]]
    ["/entity-lookup" {}
     ["" admin.entity-lookup/route]
     ["/:search-term" admin.entity-lookup/params-route]]
    ["/signal-debugger" {}
     ["" admin.signal-debugger/route]
     ["/:workspace-id/:phase/:signal" admin.signal-debugger/params-route]]
    ["/audit-log" admin.audit-log/route]
    ["/users" admin.users/route]
    ["/approver-groups" admin.approver-groups/route]
    ["/municipality-groups" admin.municipality-groups/route]
    ["/tenant-management" {}
     ["" admin.tenant-management/route]
     ["/new" admin.tenant-management-create/route]
     ["/:tenant-id" admin.tenant-management-detail/route]]
    ["/batch-group-creation" admin.batch-group-creation/route]
    ["/upper-tier-groups" admin.upper-tier-groups/route]
    ["/export-import" admin.export-import/route]
    ["/ws-export" admin.ws-export/route]
    ["/groups/:group-id" admin.groups/route]
    ["/oidc-configs" admin.oidc-configs/route]
    ["/superdomain" admin.superdomain/route]
    ["/commands"
     {:breadcrumb {:items    [:view/admin.commands]
                   :fallback (fn [{:keys [match]}]
                               (let [route-name (-> match :data :name)
                                     params     (-> match :parameters :path)]
                                 [route-name params (-> (name route-name)
                                                        (str/replace #"^admin\.commands\." ""))]))}}
     ["" admin.commands/route]
     ["/building-code-import" admin.commands.building-code-import/route]
     ["/regenerate-verdict" admin.commands.regenerate-pdf/route]
     ["/remove-user-from-workspace" admin.commands.remove-user-from-ws/route]
     ["/add-work-phase" admin.commands.add-execution-phase/route]
     ["/unblock-data-import" admin.commands.unblock-data-import/route]
     ["/manage-user-integrations" admin.user-integrations/route]
     ["/change-workspace-municipality" admin.commands.change-ws-municipality/route]
     ["/unlock-tasks" admin.commands.unlock-tasks/route]
     ["/authorize-sibling-groups" admin.commands.authorize-sibling-group/route]
     ["/create-inspection-groups" admin.commands.create-inspection-groups/route]
     ["/fix-assessment-reports" admin.commands.fix-assessment-reports/route]
     ["/queries"
      {:controllers [{:start (fn [{}]
                               (>evt [::admin.commands.queries/get-queries]))}]
       :breadcrumb  {:items    [:view/admin.commands.query]
                     :fallback (fn [{:keys [match]}]
                                 (let [route-name (-> match :data :name)
                                       params     (-> match :parameters :path)]
                                   (when (:query-key params)
                                     [route-name params (:query-key params)])))}}
      ["" admin.commands.queries/route]
      ["/:query-key" admin.commands.queries/route-query]]
     ["/workspace-delete" admin.commands.workspace-delete/route]
     ["/workspace-restore" admin.commands.workspace-restore/route]
     ["/business-delete" admin.commands.business-delete/route]
     ["/data-import-repair" admin.commands.data-import-repair/route]
     ["/remove-orphaned-businesses" admin.commands.remove-orphaned-businesses/route]
     ["/mass-delete-domain-group-properties" admin.commands.mass-delete-domain-group-properties/route]
     ["/delete-orphaned-registrations" admin.commands.delete-orphaned-registrations/route]
     ["/migrate-cr-trades" admin.commands.migrate-cr-trades/route]
     ["/change-config-path" admin.commands.change-config-path/route]
     ["/remove-duplicate-entities" admin.commands.remove-duplicate-entities/route]
     ["/remove-duplicate-user" admin.commands.remove-duplicate-user/route]
     ["/repair-cancelled-visit-booking" admin.commands.repair-cancelled-visit-booking/route]
     ["/dedupe-embeddings" admin.commands.dedupe-embeddings/route]
     ["/delete-ag-entity" admin.commands.delete-ag-entity/route]
     ["/change-email-domain" admin.migration.change-user-domain/route]
     ["/add-bill-modified-ts" admin.migration.bill-modified-ts/route]
     ["/link-acceptances-to-sub-reviews" admin.migration.link-acceptances-to-sub-reviews/route]
     ["/change-licence-number" admin.migration.change-licence-nro/route]
     ["/restrict-workspaces" admin.migration.restrict-workspaces/route]
     ["/update-inspection-template-visit-type" admin.migration.inspection-template-visit-type/route]
     ["/fix-property-integration-ids" admin.migration.fix-brantford-property-ids/route]
     ["/fix-cashier-grants" admin.migration.fix-cashiers/route]
     ["/property-geojson" admin.migration.property-geojson/route]
     ["/add-sub-review-modified-ts" admin.migration.sub-review-modified-ts/route]
     ["/generate-uri-path-ids" admin.migration.uri-path-ids/route]
     ["/add-domain-authority-users-as-domain-admins" admin.migration.add-domain-authority-users-as-domain-admins/route]
     ["/review-acceptances" admin.commands.review-acceptances/route]
     ["/remove-cashier-authz" admin.migration.remove-cashier-authz/route]
     ["/migrate-clerks-to-meeting-coordinators" admin.migration.migrate-clerks-to-meeting-coordinators/route]
     ["/create-default-agenda-templates" admin.migration.create-default-agenda-templates/route]
     ["/copy-committee-templates-to-domain" admin.migration.copy-committee-templates-to-domain/route]
     ["/move-committees-to-domain" admin.migration.move-committees-to-domain/route]
     ["/assign-domain-agenda-templates" admin.migration.assign-domain-agenda-templates/route]
     ["/enable-property-management-for-all-domains" admin.migration.enable-property-management/route]
     ["/migrate-property-units" admin.migration.migrate-property-units/route]
     ["/migrate-workspace-address-units" admin.migration.migrate-workspace-address-units/route]
     ["/revert-migrate-property-units" admin.migration.migrate-property-units/revert-route]
     ["/revert-migrate-workspace-address-units" admin.migration.migrate-workspace-address-units/revert-route]
     ["/correct-cr-work-type-category" admin.migration.correct-cr-work-type-category/route]
     ["/migrate-statcan-form-to-version-2" admin.migration.migrate-statcan-form-to-version-2/route]
     ["/activate-verified-properties" admin.migration.activate-verified-properties/route]
     ["/link-primary-addresses" admin.migration.link-primary-addresses/route]
     ["/activate-existing-addresses" admin.migration.activate-existing-addresses/route]
     ["/backfill-planning-archiving-phases" admin.migration.backfill-planning-archiving-phases/route]]
    ["/gis-configs" admin.gis-core/route]
    ["/metrics" admin.metrics/route]
    ["/feature-flags" admin.feature-flags/route]
    ["/reporting" {}
     ["" admin.reporting/route]]
    ["/api-keys" admin.api-keys/route]]

   ;;
   ;; Public notice
   ;;

   ["public-notice"
    ["/:workspace-id" public-notice-subscribe/route]]
   ["decision-download"
    ["/:workspace-id" decision-download/route]]

   ;;
   ;; Property
   ;;

   ["property"
    ["" property-dashboard/view]
    ["/:db-id" property-view/route]
    ["/:id-domain/:verified-id" property-view/verified-id-route]
    ["/:db-id/audit/log" property-audit-log/route]]
   ["property-mass-delete" property-mass-delete/route]
   ["property-gis-import"
    ["" property-gis-import/import-route]
    ["/sessions/:session-id" property-gis-import-session/route]]
   ["property-gis-update"
    ["" property-gis-import/update-route]
    ["/sessions/:session-id" property-gis-update-session/route]]

   ;;
   ;; Pre-consultation meetings view
   ;;
   ["pre-consultation-meetings" pre-consultation-meetings/view]


   ;; Bonds
   ["bonds/bond"
    ["" new-bond/route]
    ["/:bond-id" bond-view/base-route]]

   ;;
   ;; Dev
   ;;

   (when ^boolean js/goog.DEBUG
     ["dev" {}
      ["" view.dev/dev-view]
      ["/decoder" view.dev/dev-decoder-view]
      ["/fsm" view.dev/dev-fsm]])])
